import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWindowsxpComponent } from './simple-icons-windowsxp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWindowsxpComponent ],
    exports:      [ SimpleIconsWindowsxpComponent ],
    bootstrap:    []
})
export class SimpleIconsWindowsxpModule {}
